export default function getRewardfulCoupon() {
  if (typeof window === 'undefined') return;

  if (window.Rewardful && window.Rewardful.tracked) {
    return window.Rewardful.coupon;
  }

  return;
}
